import ReactPixel from 'react-facebook-pixel';
import { FB_PIXEL_ID } from 'config';

export default {
  initialized: false,
  getInstance: (): any => ReactPixel,
  initialize(): void {
    ReactPixel.init(FB_PIXEL_ID);
    this.initialized = true;
  },
  formatUserInformation(user: any) {
    return {
      ...user,
    };
  },
  setUserInformation(user: any) {
    return user;
  },
};
